'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _DateRangePickerWrapper = require('components/DateRangePickerWrapper/DateRangePickerWrapper');

var _DateRangePickerWrapper2 = _interopRequireDefault(_DateRangePickerWrapper);

var _isInclusivelyBeforeDay = require('react-dates/lib/utils/isInclusivelyBeforeDay');

var _isInclusivelyBeforeDay2 = _interopRequireDefault(_isInclusivelyBeforeDay);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var StatisticsDatePicker = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsDatePicker, _PureComponent);

  function StatisticsDatePicker() {
    var _ref;

    (0, _classCallCheck3.default)(this, StatisticsDatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatisticsDatePicker.__proto__ || (0, _getPrototypeOf2.default)(StatisticsDatePicker)).call.apply(_ref, [this].concat(args)));

    var _args$ = args[0],
        startDate = _args$.startDate,
        endDate = _args$.endDate;

    _this.state = { startDate: startDate, endDate: endDate };
    return _this;
  }

  (0, _createClass3.default)(StatisticsDatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      this.setState({ startDate: startDate, endDate: endDate });
    }
  }, {
    key: 'onChange',
    value: function onChange(_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate,
          focusedInput = _ref2.focusedInput;

      this.setState({ startDate: startDate, endDate: endDate });
      if (focusedInput !== 'startDate') {
        this.props.onChange({ startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      var onClose = this.props.onClose;
      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate;

      onClose({ startDate: startDate, endDate: endDate });
    }
  }, {
    key: 'isOutsideRange',
    value: function isOutsideRange(day) {
      return !(0, _isInclusivelyBeforeDay2.default)(day, (0, _moment2.default)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hidden = _props.hidden;
      var t = this.context.t;
      var _state2 = this.state,
          endDate = _state2.endDate,
          startDate = _state2.startDate;

      if (hidden) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_DateRangePickerWrapper2.default, {
          className: className,
          onChange: this.onChange,
          showClearDates: true,
          reopenPickerOnClearDates: true,
          showDefaultInputIcon: true,
          isOutsideRange: this.isOutsideRange,
          startDate: startDate,
          endDate: endDate,
          onClose: this.onClose
        }),
        _react2.default.createElement(
          'div',
          { className: 'hint default padding-top-5' },
          t('Please select Start and End Date')
        )
      );
    }
  }]);
  return StatisticsDatePicker;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  endDate: _propTypes2.default.string,
  hidden: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  startDate: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onChange: _noop3.default,
  onClose: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClose', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClose'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isOutsideRange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isOutsideRange'), _class.prototype)), _class);
exports.default = StatisticsDatePicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsDatePicker/StatisticsDatePicker.js
// module id = 2219
// module chunks = 1